
// jQuery('section#rdv .link').mouseenter(function () {
//     jQuery('section#rdv .ronds_container').addClass('hover');
// });

// jQuery('section#rdv .link').mouseleave(function () {
//     jQuery('section#rdv .ronds_container').removeClass('hover');
// });

var ronds_container__section_rdv = jQuery('section#rdv .ronds_container');
jQuery('section#rdv').on({
    mouseenter: function () {
        ronds_container__section_rdv.addClass('hover');
    },
    mouseleave: function () {
        ronds_container__section_rdv.removeClass('hover');
    }
}, '.link');